<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="Phone"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      id="Path_8380"
      data-name="Path 8380"
      d="M10,10a8.423,8.423,0,0,0,1.759-2.539.5.5,0,0,0-.111-.551l-.546-.545A1.02,1.02,0,0,1,11.049,4.9l.783-.783a1.333,1.333,0,0,1,1.885,0l.435.435a2.129,2.129,0,0,1,.567,1.913,10.477,10.477,0,0,1-2.974,5.282,10.477,10.477,0,0,1-5.282,2.974,2.129,2.129,0,0,1-1.913-.567l-.434-.434a1.333,1.333,0,0,1,0-1.885l.782-.782a1,1,0,0,1,1.414,0l.6.6a.5.5,0,0,0,.551.111A8.44,8.44,0,0,0,10,10Z"
      transform="translate(-1.241 -1.241)"
      fill="none"
      :stroke="clr ? clr : '#323232'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path id="Path_8381" data-name="Path 8381" d="M16,0H0V16H16Z" fill="none" />
  </svg>
</template>
